import ApplicationController from "./application_controller"

// Handles Turkish amount formatting in amount inputs.
// Display format (user-facing): 1.234,56
// Backend submit format:       1234.56
export default class CurrencyFormatterController extends ApplicationController {
  static targets = ["amountField"]

  connect() {
    // Format pre-filled values (search/edit) when form is connected.
    this.formatPreLoadedAmountValue()
  }

  // Formats amount while the user types.
  // Example typing flow:
  // - "1000"    -> "1.000"
  // - "1234,56" -> "1.234,56"
  // Keeps only digits and comma, and preserves cursor position.
  handleInput() {
    if (!this.hasAmountFieldTarget) return
    const input = this.amountFieldTarget
    const cursorPosition = input.selectionStart
    const oldValue = input.value
    const oldLength = oldValue.length

    const cleanValue = oldValue.replace(/[^\d,]/g, "")
    if (cleanValue === "" || cleanValue === ",") {
      input.value = cleanValue
      return
    }

    const parts = cleanValue.split(",")
    const integerPart = parts[0]
    const decimalPart = parts.length > 1 ? parts.slice(1).join("") : ""

    if (!integerPart || isNaN(integerPart)) return

    const number = parseInt(integerPart, 10)
    let formatted = number.toLocaleString("tr-TR")

    if (decimalPart !== "" || cleanValue.includes(",")) {
      formatted += "," + decimalPart
    }

    input.value = formatted

    const newLength = formatted.length
    const lengthDiff = newLength - oldLength
    const newCursorPosition = cursorPosition + lengthDiff
    input.setSelectionRange(newCursorPosition, newCursorPosition)
  }

  // Formats pre-filled values for search/edit fields.
  // Examples:
  // - "1000.5"  -> "1.000,5"
  // - "1234.56" -> "1.234,56"
  formatPreLoadedAmountValue() {
    if (!this.hasAmountFieldTarget) return
    const input = this.amountFieldTarget
    let rawValue = input.value.trim()
    if (rawValue === "") return

    // Supports both:
    // - Backend format: "1234.56"
    // - Turkish display format: "1.234,56"
    if (rawValue.includes(".") && rawValue.includes(",")) {
      rawValue = rawValue.replace(/\./g, "").replace(/,/g, ".")
    } else if (rawValue.includes(",")) {
      rawValue = rawValue.replace(/,/g, ".")
    }

    if (isNaN(rawValue)) return

    const number = parseFloat(rawValue)
    input.value = number.toLocaleString("tr-TR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20
    })
  }

  // Converts display format to backend format before form submit.
  // Example:
  // - "1.234,56" -> "1234.56"
  cleanAmountBeforeSubmit() {
    if (!this.hasAmountFieldTarget) return
    this.amountFieldTarget.value = this.amountFieldTarget.value.replace(/\./g, "").replace(/,/g, ".")
  }
}
